import { render, staticRenderFns } from "./StudentRegisterSubject.vue?vue&type=template&id=a2d4695e&"
import script from "./StudentRegisterSubject.vue?vue&type=script&lang=js&"
export * from "./StudentRegisterSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports